'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

require('./button.scss');

var _classnames = require('../../utils/classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function renderChildren(children) {
  // All text nodes need to be places inside of a element, so that we can use :first-child and :last-child
  return [].concat(children).map(function (child) {
    if (typeof child === 'string') {
      return _react2.default.createElement(
        'span',
        { className: 'button__text', key: child },
        child
      );
    }

    return child;
  });
}

function Button(_ref) {
  var action = _ref.action,
      color = _ref.color,
      size = _ref.size,
      children = _ref.children,
      className = _ref.className,
      disabled = _ref.disabled,
      type = _ref.type,
      props = _objectWithoutProperties(_ref, ['action', 'color', 'size', 'children', 'className', 'disabled', 'type']);

  var classes = (0, _classnames2.default)('button', 'button--' + color, 'button--' + size, type && 'button--' + type, disabled && 'button--disabled', className);

  return _react2.default.createElement(
    'button',
    _extends({
      className: classes,
      type: action
    }, props),
    _react2.default.createElement(
      'span',
      { className: 'button__content' },
      renderChildren(children)
    )
  );
}

// TODO refactor type, action and color properties ....
// type => shape ; action => type
// TODO I think type="tabs" is not used any more and can be removed.

Button.propTypes = {
  className: _propTypes2.default.string,
  children: _propTypes2.default.node,
  color: _propTypes2.default.oneOf(['primary', 'secondary', 'dark', 'light', 'neutral', 'disabled']),
  size: _propTypes2.default.oneOf(['small', 'medium', 'large', 'x-large', 'xx-large']),
  type: _propTypes2.default.oneOf(['default', 'outlined', 'link', 'tab']),
  action: _propTypes2.default.oneOf(['submit', 'button', 'reset']),
  disabled: _propTypes2.default.bool,
  onClick: _propTypes2.default.func
};

Button.defaultProps = {
  color: 'neutral',
  size: 'medium',
  action: 'submit'
};

exports.default = Button;